import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { ClipboardButton } from 'components/ClipboardButton';
import { Heading } from 'components/Heading';
import { MobileScreen } from 'components/MobileScreen';
import { getFileExtension, getPhotoUrl, useOnline } from 'engine/api';
import { useStore, useTeam } from 'engine/store';
import { User } from 'lucide-react';
import { useState } from 'react';

export const Route = createFileRoute('/settings')({
	component: RouteComponent,
	beforeLoad: async () => {
		const { game } = useStore.getState();

		if (!game) throw redirect({ to: '/' });
	},
});

function RouteComponent() {
	const isOnline = useOnline();
	const { eventId, leaveEvent, game } = useStore((state) => state);
	const router = useRouter();
	const team = useTeam();
	const { deviceId } = useStore();
	const [debugCounter, setDebugCounter] = useState(0);

	return (
		<MobileScreen className="flex flex-col gap-4">
			<Heading mode="primary">
				<button
					className="cursor-default"
					onClick={() => {
						setDebugCounter(debugCounter + 1);
						if (debugCounter >= 10) {
							setDebugCounter(0);
							router.navigate({ to: '/debug' });
						}
					}}
				>
					{__`Settings`}
				</button>
			</Heading>
			<div className="flex flex-col gap-2">
				<Heading mode="tertiary">{__`Team info`}</Heading>
				<span>
					<strong>{__`Name`}:</strong> {team?.name}
				</span>
				<span>
					<strong>{__`DeviceCode`}:</strong> {deviceId}
				</span>
				{team?.data?.members && team.data.members.length > 0 && (
					<div className="flex flex-col gap-2">
						<strong>{__`Members`}:</strong>
						<ul className="list-disc pl-4">
							{team.data.members.map((m) => (
								<li key={m.id}>{m.name}</li>
							))}
						</ul>
					</div>
				)}
				{!game?.hideScore && (
					<span>
						<strong>{__`Score`}:</strong> {team?.score}
					</span>
				)}
				{team?.rejoinCode && (
					<span>
						<strong>{__`TeamCode`}:</strong> {team.rejoinCode} <ClipboardButton value={team.rejoinCode} />
					</span>
				)}
			</div>
			<hr />

			{TeamAvatar({ eventId, teamId: team?.id, avatar: team?.data?.avatar })}

			{/* <AvatarUploadForm disabled={!isOnline} /> */}
			<hr />
			<Button
				disabled={!isOnline}
				onClick={() => {
					leaveEvent();
					router.navigate({ to: '/' });
				}}
			>
				{__`Leave event`}
			</Button>
		</MobileScreen>
	);
}

interface TeamAvatarProps {
	avatar?: {
		id: string;
		mimeType: string;
		filename: string;
	} | null;
	eventId?: string;
	teamId?: string;
}

export const TeamAvatar = ({ avatar, eventId, teamId }: TeamAvatarProps) => {
	if (avatar && eventId && teamId) {
		return (
			<img
				src={getPhotoUrl(avatar.id, getFileExtension(avatar.filename)!, teamId, eventId!)}
				alt="avatar"
				className="size-8 overflow-hidden rounded-full bg-black object-cover"
			/>
		);
	}

	return (
		<div className="flex size-20 items-center justify-center rounded-full border border-gray-200 bg-gray-100">
			<User className="size-16 text-gray-400" />
		</div>
	);
};

// function AvatarUploadForm({ disabled }: { disabled: boolean }) {
// 	const eventId = useStore((state) => state.eventId);
// 	const teamId = useStore((state) => state.teamId);
// 	const team = useTeam();
// 	const navigate = useNavigate();

// 	const AvatarSchema = z.object({
// 		avatar: z
// 			.any()
// 			.transform((val) => (val instanceof FileList ? val[0] : val))
// 			.refine((file) => !file || file instanceof File, {
// 				message: 'Invalid file',
// 			})
// 			.optional(),
// 	});

// 	type AvatarFormData = z.infer<typeof AvatarSchema>;

// 	const { register, handleSubmit } = useForm<AvatarFormData>({
// 		resolver: zodResolver(AvatarSchema),
// 	});

// 	const onSubmitAvatar = async (data: AvatarFormData) => {
// 		if (disabled) return;

// 		if (!eventId || !teamId) {
// 			console.error('eventId or teamId is undefined');
// 			return;
// 		}

// 		const avatarUploaded = !!data.avatar;
// 		const avatarCleared = !!team?.data?.avatar && !data.avatar;

// 		if (avatarUploaded || avatarCleared) {
// 			console.log('uploading avatar', data.avatar);
// 			await uploadAvatar(data.avatar, eventId, teamId).then(() => {
// 				toast.success('Avatar updated');
// 				navigate({ to: '/' });
// 			});
// 		}
// 	};

// 	const currentAvatarUrl = team?.data?.avatar ? getAvatarUrl(eventId!, team.id, team.data.avatar) : undefined;

// 	return (
// 		<div className="flex flex-col gap-2">
// 			<Heading mode="tertiary">{__`Avatar`}</Heading>
// 			<form
// 				onSubmit={handleSubmit(onSubmitAvatar)}
// 				data-disabled={disabled ? '' : undefined}
// 				className="flex flex-col gap-2 data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
// 			>
// 				<AvatarUpload register={register} defaultValue={currentAvatarUrl} />
// 				<Button type="submit">{__`Update avatar`}</Button>
// 			</form>
// 		</div>
// 	);
// }
